import IFFilterType from 'Enums/IFFilterType'
import RequestState from 'Enums/RequestState'
import { createMongoAbility } from '@casl/ability'

export const INITIAL_STATE = {
  loginLoading: false,
  token: null,
  refreshToken: null,
  user: null,
  editingAdminRole: createMongoAbility([]),
  resetPasswordVerificationRequestState: RequestState.UNINITIALIZED,
  fetchEditingAdminRoleRequestState: RequestState.UNINITIALIZED,
  fetchAdminDetailsRequestState: RequestState.UNINITIALIZED,
  ChangingPasswordRequestState: RequestState.UNINITIALIZED,
  ChangingUserNameRequestState: RequestState.UNINITIALIZED,

  fetchAdminActionsRequestState: RequestState.UNINITIALIZED,
  adminActions: [],
  adminActionPaginationOffset: 0,
  adminActionsFilters: [
    {
      type: IFFilterType.KEYWORD,
      title: null,
      data: null,
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.DATE_RANGE,
      title: 'Date',
      initialValue: [],
      value: [],
    },
    {
      type: IFFilterType.CHECK,
      title: 'Action',
      data: ['Create', 'Edit', 'Delete', 'Activate', 'Deactivate', 'Invite'],
      initialValue: [],
      value: [],
    },
  ],
  resetPasswordRequestState: RequestState.UNINITIALIZED,
  resetPasswordEmailID: '',
  requires2FASetup: false,
  challengeId: '',
  otpauthUrl: '',
  manualKey: '',
  requires2FA: false,
  loginToken: '',
  setUp2FaComplete: false,
}
